import React from "react";

interface TechStat {
  label: string;
  value: string;
  icon: string;
  description: string;
  accent: string;
}

const stats: TechStat[] = [
  {
    label: "Skills",
    value: "Frontend, Mobile & Backend",
    icon: "🛠️",
    description: "100% Capable Full-Stack",
    accent: "var(--accent)",
  },
  {
    label: "Full-Stack",
    value: "100%",
    icon: "🔁",
    description: "Capable across frontend, mobile & backend",
    accent: "var(--accent-cool)",
  },
  {
    label: "API Endpoints",
    value: "500+",
    icon: "🔌",
    description: "Built & Deployed",
    accent: "var(--accent-warm)",
  },
  {
    label: "Experience",
    value: "7+ yrs",
    icon: "🚀",
    description: "Backend Development",
    accent: "var(--accent-violet)",
  },
];

const BackendStats: React.FC = () => {
  return (
    <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4 md:gap-4">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="home-metric-card relative min-h-[168px] overflow-hidden rounded-lg border border-border bg-bg-elevated/85 p-4 transition-all duration-300 group hover:-translate-y-1 hover:border-border-hover md:p-5"
        >
          <div
            className="absolute inset-x-0 top-0 h-0.5"
            style={{
              background: `linear-gradient(90deg, ${stat.accent}, transparent)`,
            }}
          />
          <div className="relative z-10 flex h-full flex-col">
            <div className="mb-4 flex items-center justify-between">
              <span className="text-2xl md:text-3xl">{stat.icon}</span>
              <span
                className="h-2 w-2 rounded-full"
                style={{ background: stat.accent }}
              />
            </div>
            <div className="mb-2 text-xl font-bold leading-tight tracking-normal md:text-2xl font-display text-text-primary">
              {stat.value}
            </div>
            <div className="text-xs font-mono uppercase tracking-wider text-text-muted mb-1">
              {stat.label}
            </div>
            <div className="mt-auto text-xs leading-relaxed text-text-secondary">
              {stat.description}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BackendStats;
